import { RouterOutlet } from '@angular/router';
import { Component, OnInit, Signal, computed, inject } from '@angular/core';

import { ShellComponent } from './shared/shell/shell.component';
import { LanguageService } from './core/services/language.service';
import { Location } from '@angular/common';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  imports: [RouterOutlet, ShellComponent],
})
export class AppComponent implements OnInit {
  loc: Location = inject(Location);

  get isOutlet(): boolean {
    return ['/ng-app-shell'].includes(this.loc.path()) === false;
  }

  title = 'esign';
  languageService = inject(LanguageService);

  translationsLoaded: Signal<boolean> = computed(() =>
    this.languageService.translationsLoaded(),
  );

  async ngOnInit() {
    await this.languageService.initializeApp();
  }
}
